import { Badge } from '@synoptic/ui-kit/badge/badge.js';
import { TrophyIcon } from '@synoptic/ui-kit/icons/react/trophy.tsx';
import { Wrap } from '@synoptic/ui-kit/wrap.js';
import { clsx } from 'clsx';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { badge, labelContent, postLabelIcon } from './post-label.css.ts';

export const TournamentLabel = ({
  label,
  tournamentId,
  className,
  linkToTournament = false,
}: {
  label: string;
  tournamentId: string;
  className?: string;
  linkToTournament?: boolean;
}) => (
  <Wrap
    if={linkToTournament}
    with={Link}
    to={paths.makeTournament(tournamentId)}
  >
    <Badge
      color={'brand'}
      className={clsx(badge, className)}
      interactive={linkToTournament}
    >
      <TrophyIcon className={postLabelIcon} />

      <span className={labelContent}>{label}</span>
    </Badge>
  </Wrap>
);
